import { lazy } from 'react';

// Define route constants
export const ROUTES = {
  HOME: '/',
  CHAT_DETAILS: '/chat/:id',
  SETTINGS: '/settings',
  LOGIN: '/login',
  STREAM_DEMO: '/lab/stream-demo',
  SURFACE_DEMO: '/lab/surface-demo',
  SKINS_DEMO: '/lab/skins',
  MODEL_PICKER: '/lab/model-picker',
  CONNECTORS: '/connectors',
  WORLDS: '/worlds',
  USAGE_ME: '/usage/me',
  USAGE_ORG: '/usage/org',
  OAUTH_GMAIL: '/oauth/gmail/callback',
  PRIVACY: '/privacy',
  TERMS: '/terms',
};

// Define route configurations
export const routeConfig = [
  {
    path: ROUTES.HOME,
    component: lazy(() => import('./pages/NewChat')),
  },
  {
    path: ROUTES.CHAT_DETAILS,
    component: lazy(() => import('./pages/Prompt')),
  },
  {
    path: ROUTES.SETTINGS,
    component: lazy(() => import('./pages/Settings')),
  },
  {
    path: ROUTES.STREAM_DEMO,
    component: lazy(() => import('./pages/StreamDemo')),
  },
  {
    path: ROUTES.SURFACE_DEMO,
    component: lazy(() => import('./pages/SurfaceDemo')),
  },
  {
    path: ROUTES.SKINS_DEMO,
    component: lazy(() => import('./pages/SkinsDemo')),
  },
  {
    path: ROUTES.MODEL_PICKER,
    component: lazy(() => import('./pages/LabModelPicker')),
  },
  {
    path: ROUTES.CONNECTORS,
    component: lazy(() => import('./pages/Connectors')),
  },
  {
    path: ROUTES.WORLDS,
    component: lazy(() => import('./pages/Worlds')),
  },
  {
    path: ROUTES.USAGE_ME,
    component: lazy(() => import('./pages/UsageMe')),
  },
  {
    path: ROUTES.USAGE_ORG,
    component: lazy(() => import('./pages/UsageOrg')),
  },
  {
    path: ROUTES.OAUTH_GMAIL,
    component: lazy(() => import('./pages/OAuthGmailCallback')),
  },
  {
    path: ROUTES.PRIVACY,
    component: lazy(() => import('./pages/Legal')),
  },
  {
    path: ROUTES.TERMS,
    component: lazy(() => import('./pages/Legal')),
  },
];

// A utility function to get a route path with parameters
export const getRoutePath = (route, params = {}) => {
  let path = ROUTES[route];
  Object.keys(params).forEach((key) => {
    path = path.replace(`:${key}`, params[key]);
  });
  return path;
};
